import { set } from 'lodash';
import { store } from './store';

/**
 * Check if products where loaded already.
 * If not, load products into the store
 * @memberof module:loadContent
 */
export const loadContent = () => {
    // Load dashboard_banners
    if (!store.getters['settings/isContentLoadedOrLoading']('dashboard_banners')) {
        const dashboard_banners_config = {};
        store.commit('settings/contentLoading', 'dashboard_banners');
        store.dispatch('dashboard_banners/index', dashboard_banners_config).then(() => {
            store.commit('settings/contentLoaded', 'dashboard_banners');
        });
    }

    // Load user
    if (!store.getters['settings/isContentLoadedOrLoading']('user')) {
        const user_config = {};
        store.commit('settings/contentLoading', 'user');
        store.dispatch('user/user', user_config).then(() => {
            store.commit('settings/contentLoaded', 'user');
        });
    }

    // Load price targets
    if (!store.getters['settings/isContentLoadedOrLoading']('price_targets')) {
        store.commit('settings/contentLoading', 'price_targets');
        store.dispatch('price_targets/index').then(() => {
            store.commit('settings/contentLoaded', 'price_targets');
        });
    }

    // Load trades
    if (!store.getters['settings/isContentLoadedOrLoading']('trades')) {
        const trades_config = {
            params: {
                subscribed_abos: true,
                sort: ''
            }
        };
        store.commit('settings/contentLoading', 'trades');
        store.dispatch('trades/index', trades_config).then(() => {
            store.commit('settings/contentLoaded', 'trades');
        });
    }

    // Load contentstreams
    if (!store.getters['settings/isContentLoadedOrLoading']('contentstreams')) {
        let $big = 1;
        let $huge = 1;
        for (let i = 0; i < $huge; i++) {
            const contentstreams_config = {
                params: {
                    'sort[by]': 'published_at',
                    'sort[order]': 'desc',
                    page_size: 20,
                    page: i + 1,
                    key: 'dashboard',
                    append_to_list: true
                }
            };

            if (i === 0) {
                store.commit('settings/contentLoading', 'contentstreams');
            } else if (i === $big - 1) {
                store.commit('settings/contentLoading', 'contentstreams_big');
            } else if (i === $huge - 1) {
                store.commit('settings/contentLoading', 'contentstreams_huge');
            }

            store.dispatch('contentstreams/index', contentstreams_config).then((response) => {
                if (i === 0) {
                    $big = Math.min(response.meta?.last_page, $big);
                    $huge = Math.min(response.meta?.last_page, $huge);
                    store.commit('settings/contentLoaded', 'contentstreams');
                } else if (i === $big - 1) {
                    store.commit('settings/contentLoaded', 'contentstreams_big');
                    const uniqueBookedProducts = [...new Set(store.getters['contentstreams/all']?.dashboard?.data.map((item) => item.product_id))]?.length ?? 0;
                    console.log('NO of products loaded: ', (Math.ceil(uniqueBookedProducts * 0.8) + $big) * 40);
                    $huge = Math.min(response.meta?.last_page, Math.ceil(uniqueBookedProducts * 0.8));
                } else if (i === $huge - 1) {
                    store.commit('settings/contentLoaded', 'contentstreams_huge');
                }
            });
        }
    }
};
